//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  computed: {
    appGroups: function appGroups() {
      return this.app.groups.map(function (group) {
        return {
          id: group,
          name: group
        };
      });
    },
    loading: function loading() {
      var self = this;
      return function (id) {
        return self.$store.getters.loading(id);
      };
    },
    installing: function installing() {
      return this.$store.getters.loading('install');
    },
    enableButtonText: function enableButtonText() {
      if (this.app.needsDownload) {
        return t('settings', 'Download and enable');
      }

      return t('settings', 'Enable');
    },
    forceEnableButtonText: function forceEnableButtonText() {
      if (this.app.needsDownload) {
        return t('settings', 'Enable untested app');
      }

      return t('settings', 'Enable untested app');
    },
    enableButtonTooltip: function enableButtonTooltip() {
      if (this.app.needsDownload) {
        return t('settings', 'The app will be downloaded from the app store');
      }

      return false;
    },
    forceEnableButtonTooltip: function forceEnableButtonTooltip() {
      var base = t('settings', 'This app is not marked as compatible with your Nextcloud version. If you continue you will still be able to install the app. Note that the app might not work as expected.');

      if (this.app.needsDownload) {
        return base + ' ' + t('settings', 'The app will be downloaded from the app store');
      }

      return base;
    }
  },
  mounted: function mounted() {
    if (this.app.groups.length > 0) {
      this.groupCheckedAppsData = true;
    }
  },
  methods: {
    asyncFindGroup: function asyncFindGroup(query) {
      return this.$store.dispatch('getGroups', {
        search: query,
        limit: 5,
        offset: 0
      });
    },
    isLimitedToGroups: function isLimitedToGroups(app) {
      if (this.app.groups.length || this.groupCheckedAppsData) {
        return true;
      }

      return false;
    },
    setGroupLimit: function setGroupLimit() {
      if (!this.groupCheckedAppsData) {
        this.$store.dispatch('enableApp', {
          appId: this.app.id,
          groups: []
        });
      }
    },
    canLimitToGroups: function canLimitToGroups(app) {
      if (app.types && app.types.includes('filesystem') || app.types.includes('prelogin') || app.types.includes('authentication') || app.types.includes('logging') || app.types.includes('prevent_group_restriction')) {
        return false;
      }

      return true;
    },
    addGroupLimitation: function addGroupLimitation(group) {
      var groups = this.app.groups.concat([]).concat([group.id]);
      this.$store.dispatch('enableApp', {
        appId: this.app.id,
        groups: groups
      });
    },
    removeGroupLimitation: function removeGroupLimitation(group) {
      var currentGroups = this.app.groups.concat([]);
      var index = currentGroups.indexOf(group.id);

      if (index > -1) {
        currentGroups.splice(index, 1);
      }

      this.$store.dispatch('enableApp', {
        appId: this.app.id,
        groups: currentGroups
      });
    },
    forceEnable: function forceEnable(appId) {
      this.$store.dispatch('forceEnableApp', {
        appId: appId,
        groups: []
      }).then(function (response) {
        OC.Settings.Apps.rebuildNavigation();
      }).catch(function (error) {
        OC.Notification.show(error);
      });
    },
    enable: function enable(appId) {
      this.$store.dispatch('enableApp', {
        appId: appId,
        groups: []
      }).then(function (response) {
        OC.Settings.Apps.rebuildNavigation();
      }).catch(function (error) {
        OC.Notification.show(error);
      });
    },
    disable: function disable(appId) {
      this.$store.dispatch('disableApp', {
        appId: appId
      }).then(function (response) {
        OC.Settings.Apps.rebuildNavigation();
      }).catch(function (error) {
        OC.Notification.show(error);
      });
    },
    remove: function remove(appId) {
      this.$store.dispatch('uninstallApp', {
        appId: appId
      }).then(function (response) {
        OC.Settings.Apps.rebuildNavigation();
      }).catch(function (error) {
        OC.Notification.show(error);
      });
    },
    install: function install(appId) {
      this.$store.dispatch('enableApp', {
        appId: appId
      }).then(function (response) {
        OC.Settings.Apps.rebuildNavigation();
      }).catch(function (error) {
        OC.Notification.show(error);
      });
    },
    update: function update(appId) {
      this.$store.dispatch('updateApp', {
        appId: appId
      }).then(function (response) {
        OC.Settings.Apps.rebuildNavigation();
      }).catch(function (error) {
        OC.Notification.show(error);
      });
    }
  }
};